import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UploadFileToServerComponent } from '@shared/modules/print-file-shared/components/upload-file-to-server/upload-file-to-server.component';
import { allowedFileExtensions } from '@shared/constants/allowedFileExtensions';
import { typesUploading } from '@shared/constants/types-uploading';
import { ITransferResources } from '@shared/interfaces/resources/transfer-resources';
import { IPrintUploadPreview } from '@shared/modules/print-file-shared/interfaces/print-upload-preview';

@Component({
  selector: 'app-multiprint-first-step',
  templateUrl: './multiprint-first-step.component.html',
  styleUrls: ['./multiprint-first-step.component.scss']
})
export class MultiprintFirstStepComponent implements OnInit {
  @ViewChild(UploadFileToServerComponent) uploadComponent!: UploadFileToServerComponent;
  @Input() transferResources!: ITransferResources;
  @Output() finishStep = new EventEmitter<IPrintUploadPreview>();

  typesUploading: Readonly<any> = typesUploading;
  readonly allowedFileExtensions = allowedFileExtensions.multiPrint;

  constructor() { }

  ngOnInit(): void {
  }

  chartData(): Array<{ name: string, value: number }> {
    return [
      {
        name: "",
        value: this.transferResources.currentTransfer
      },
      {
        name: "",
        value: Math.max(0, this.transferResources.totalTransfer - this.transferResources.currentTransfer)
      }
    ];
  }


  onFileUploaded(callbackInformation: { isSuccess: boolean, hideModal: boolean, data: any }): void {
    if (callbackInformation.isSuccess && callbackInformation.data) {
      this.finishStep.next(callbackInformation.data);
    } else {
      this.uploadComponent.clearData();
    }
  }
}
